
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-3">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createLabel">
              <h2>Cadastro de Labels</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Titulo</label>
                <input
                  type="text"
                  placeholder="IMPORTANTE"
                  class="form-control"
                  v-model="registerForm.form.title"
                />
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cor de fundo</label>
                    <input
                      type="color"
                      class="form-control"
                      v-model="registerForm.form.backgroundColor"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cor da fonte</label>
                    <input
                      type="color"
                      class="form-control"
                      v-model="registerForm.form.foregroundColor"
                    />
                  </div>
                </div>
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  registerForm.control.createButtonIsDisabled ||
                  !permissionUpdate
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Label
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                    !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-9 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Labels</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.title"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchLabels"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>title</th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr
                :class="{ unread: listItem.accountEnabled }"
                v-for="(listItem, listIdx) in registerList.list"
                :key="listIdx"
              >
                <td>{{ listItem.title }}</td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem, listIdx)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Excluir"
                    v-if="permissionDelete"
                    @click="removeLabel(listItem)"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'RegisterEmployee',
  directives: { mask },
  data() {
    return {
      registerForm: {
        form: {
          title: '',
          foregroundColor: '#000000',
          backgroundColor: '#000000',
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
          roleList: [],
        },
      },
      searchForm: {
        form: {
          title: '',
        },
        control: {},
      },
      registerList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('labels', 'CREATE');
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('labels', 'READ');
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('labels', 'UPDATE');
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess']('labels', 'DELETE');
    },
  },
  watch: {
    'searchForm.form.title'() {
      this.searchLabels();
    },
  },
  mounted() {
    this.listLabels();
  },
  methods: {
    async listLabels() {
      if (!this.permissionRead) {
        return;
      }
      const labels = await this.$store.dispatch('LABELS/All');
      this.registerList.originalList = labels;
      this.searchLabels();
    },
    searchLabels() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.registerList.originalList.filter(item => {
        return (
          item.title
            .toUpperCase()
            .indexOf(this.searchForm.form.title.toUpperCase()) > -1
        );
      });
      this.registerList.list = listFiltered;
    },
    async createLabel() {
      if (!this.permissionCreate) {
        return;
      }

      this.registerForm.control.createButtonIsDisabled = true;

      const payload = {
        ...this.registerForm.form,
      };

      try {
        await this.$store.dispatch('LABELS/Create', payload);
        this.listLabels();

        this.registerForm.form.title = '';
        this.registerForm.form.foregroundColor = '#00000';
        this.registerForm.form.backgroundColor = '#00000';

        this.$toasted.success('Label inserida com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    enterEditMode(registerItem) {
      this.registerForm.control.editModeId = registerItem._id;
      this.registerForm.form.title = registerItem.title;
      this.registerForm.form.foregroundColor = registerItem.foregroundColor;
      this.registerForm.form.backgroundColor = registerItem.backgroundColor;
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.title = '';
      this.registerForm.form.foregroundColor = '#00000';
      this.registerForm.form.backgroundColor = '#00000';
    },
    async saveEdition() {
      this.registerForm.control.createButtonIsDisabled = true;

      const labelId = this.registerForm.control.editModeId;

      const payload = {
        ...this.registerForm.form,
      };

      try {
        await this.$store.dispatch('LABELS/Update', { payload, labelId });
        this.listLabels();

        this.disableEditMode();

        this.$toasted.success('Label salva com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    async removeLabel({ _id }) {
      try {
        const labelId = _id;

        await this.$store.dispatch('LABELS/Delete', labelId);
        this.listLabels();
        this.$toasted.success('Label removida com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      }
    },
  },
};
</script>